import type { TFunction } from 'i18next';

import { parseApiError } from '../../../utils/parseApiError';

/** Codes the backend's OrganizationTeamService puts on its refusals. */
export const TEAM_ERROR_CODES = [
  'NOT_AN_OWNER',
  'ORG_NOT_FOUND',
  'ROLE_NOT_FOUND',
  'ROLE_HELD',
  'ROLE_NAME_TAKEN',
  'ROLE_NAME_RESERVED',
  'PERMISSION_NOT_GRANTABLE',
  'NOT_A_MEMBER',
  'USER_NOT_FOUND',
  'PHONE_NOT_FOUND',
  'ALREADY_IN_ORG',
  'IN_OTHER_ORG',
  'OWNS_THIS_ORG',
  'OWNS_ORG',
  'PLATFORM_ROLE',
] as const;

const known = new Set<string>(TEAM_ERROR_CODES);

/** A team write's failure in plain words; the server text only for unknown errors. */
export function teamErrorText(err: unknown, t: TFunction): string {
  const { code, message } = parseApiError(err);
  return code && known.has(code) ? t(`dashboard.team.errors.${code}`) : message;
}
